import _ from 'lodash';
import React from 'react';
import autobind from 'autobind-decorator';
import { inject, observer } from 'mobx-react';

import {HFMModalNeo} from 'client/shared/components';

import AlbumModalContent from './album-modal-content';

class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError(error) {
		// Update state so the next render will show the fallback UI.
		return { hasError: true };
	}

	componentDidCatch(error, info) {
		// You can also log the error to an error reporting service
		console.log('[ErrorBoundary - AlbumModal]', error, info);
	}

	render() {
		if (this.state.hasError) {

			// You can render any custom fallback UI
			return <h1>Something went wrong.</h1>;
		}

		return this.props.children;
	}
}

@inject('albumsStore')
@observer
class AlbumModal extends React.Component {
	state = {
		modalOpen: false
	}

	componentWillMount () {
		const { albumsStore } = this.props;

		this.album = this.props.album;

		if  (_.isEmpty(this.album)) {

			this.album = albumsStore.newAlbum();
		}
	}

	render () {
		const {
			albumsStore,
			wrapperClassName,
			button: LaunchModalButton
		} = this.props;

		let { album } = this;

		if (_.isObject(albumsStore.modalEditAlbum)) {

			album = albumsStore.modalEditAlbum;
		}

		return (
			// <ErrorBoundary>
			<div className={ wrapperClassName }>
				<HFMModalNeo
					contentLabel="Edit Album"
					isOpen={ albumsStore.albumModalOpen }
				>
					<AlbumModalContent
						album={ album }
						handleCloseModal={ this.handleCloseModal }
					/>
				</HFMModalNeo>

				<LaunchModalButton onClick={ this.handleOpenModal } />
			</div>
			// </ErrorBoundary>
		);
	}

	@autobind
	handleOpenModal () {
		this.props.albumsStore.albumModalOpen = true;
	}

	@autobind
	handleCloseModal () {
		const { albumsStore } = this.props;

		albumsStore.removeUnsavedAlbums();
		albumsStore.albumModalOpen = false;
		albumsStore.modalEditAlbum = null;
	}
}

export default AlbumModal;
